export default "__VITE_ASSET__BUBP52yJ__"